import './home.scss';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { RouteComponentProps } from 'react-router-dom';
import { Row, Col } from 'antd';
import { Storage } from 'react-jhipster';
import { getEcole } from 'app/entities/ecole/ecole.reducer';
import { useAppSelector, useAppDispatch } from 'app/config/store';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Filler, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import moment from 'moment';
import { APP_LOCAL_MONTH_FORMAT } from 'app/config/constants';

const apiUrl = 'api/dashboard';
export const getEcoleDashboardUrl = (ecoleId: string) => `${apiUrl}/ecole?ecoleId=${ecoleId}`;

export const Home = (props: RouteComponentProps<{ ecoleid: string; anneeScolaireId: string }>) => {
  const [totalEleve, setTotalEleve] = useState(0);
  const [eleveAJour, setEleveAJour] = useState(0);
  const [eleveNonAJour, setEleveNonAJour] = useState(0);
  const [eleveAbsents, setEleveAbsents] = useState(0);
  const [elevePresents, setElevePresents] = useState(0);
  const [totalProf, setTotalProf] = useState(0);
  const [profPresent, setProfPresent] = useState(0);
  const [profAbsent, setProfAbsent] = useState(0);
  const [ecoleData, setEcoleData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalPersonnel, setTotalPersonnel] = useState(0);
  const [personnelPresent, setPersonnelPresent] = useState(0);
  const [personnelAbsents, setPersonnelAbsents] = useState(0);

  ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Filler, Legend);

  const dispatch = useAppDispatch();
  const token = Storage.local.get('jhi-authenticationToken') || Storage.session.get('jhi-authenticationToken');
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const getDashbord = () => {
    if (token) {
      axios
        .get(`${apiUrl}/${props.match.params.ecoleid}?anneeScolaireId=${props.match.params.anneeScolaireId}`, {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        })
        .then(response => {
          setLoading(!loading);
          setTotalEleve(response.data.totalEleve);
          setEleveAJour(response.data.eleveAJour);
          setEleveNonAJour(response.data.eleveNonAJour);
          setEleveAbsents(response.data.eleveAbsents);
          setElevePresents(response.data.elevePresents);
          setTotalProf(response.data.totalProf);
          setProfPresent(response.data.profPresent);
          setProfAbsent(response.data.profAbsents);
          setTotalPersonnel(response.data.totalPersonnel);
          setPersonnelPresent(response.data.personnelPresent);
          setPersonnelAbsents(response.data.personnelAbsents);
        });
    }
  };
  const getEcoleDashbord = () => {
    if (token) {
      axios
        .get(getEcoleDashboardUrl(props.match.params.ecoleid), {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        })
        .then(response => {
          setLoading(!loading);
          setEcoleData(response.data);
        });
    }
  };
  useEffect(() => {
    dispatch(getEcole(props.match.params.ecoleid));
    getEcoleDashbord();
    getDashbord();
    const interval = setInterval(() => getDashbord(), 10000);
    return () => clearInterval(interval);
  }, []);

  const dataPresenceEleves = {
    labels: ['Elèves Absents', 'Elèves Présents'],
    datasets: [
      {
        labels: 'Présence des élèves',
        data: [eleveAbsents, elevePresents],
        backgroundColor: ['#bf616a', '#a3be8c'],
      },
    ],
  };

  const dataPaiementEleves = {
    labels: [' Elèves A Jour ', 'Elèves NonAJour'],
    datasets: [
      {
        label: 'Etat de paiement des élèves',
        data: [eleveAJour, eleveNonAJour],
        backgroundColor: ['rgba(75,192,192,1)', 'rgb(255, 99, 132,0.7)'],
      },
    ],
    center: {
      display: true,
      text: '280',
    },
  };

  const dataProf = {
    labels: ['Enseignants Absents', 'Enseignants Présents'],
    datasets: [
      {
        labels: 'Présence des enseignants',
        data: [profAbsent, profPresent, '', ''],
        backgroundColor: ['#ffcb75', 'rgba(50, 115, 220, 0.5)'],
      },
    ],
  };

  const dataPersonnel = {
    labels: ['Personnel Absent', 'Personnel Présent'],
    datasets: [
      {
        labels: 'Présence du personnel',
        data: [personnelAbsents, personnelPresent, '', ''],
        backgroundColor: ['#ffcb75', '#a3be8c'],
      },
    ],
  };

  const bar1 = {
    labels: ecoleData.map(e => moment(e.date).format(APP_LOCAL_MONTH_FORMAT)),
    datasets: [
      {
        label: 'Élèves présents',
        data: ecoleData.map(e => e.elevePresents),
        backgroundColor: 'rgba(147, 197, 114, 0.7)',
        stack: 'stack1',
      },
      {
        label: 'Élèves absents',
        data: ecoleData.map(e => e.eleveAbsents),
        backgroundColor: 'rgba(170, 74, 68, 0.7)',
        stack: 'stack1',
      },
    ],
  };

  const bar2 = {
    labels: ecoleData.map(e => moment(e.date).format(APP_LOCAL_MONTH_FORMAT)),
    datasets: [
      {
        label: 'Enseignants présents',
        data: ecoleData.map(e => e.profPresent),
        backgroundColor: 'rgba(147, 197, 114, 0.7)',
        stack: 'stack1',
      },
      {
        label: 'Enseignants absents',
        data: ecoleData.map(e => e.profAbsent),
        backgroundColor: 'rgba(170, 74, 68, 0.7)',
        stack: 'stack1',
      },
    ],
  };

  const bar3 = {
    labels: ecoleData.map(e => moment(e.date).format(APP_LOCAL_MONTH_FORMAT)),
    datasets: [
      {
        label: 'Élèves A Jour',
        data: ecoleData.map(e => e.eleveAJour),
        backgroundColor: 'rgba(147, 197, 114, 0.7)',
        stack: 'stack1',
      },
      {
        label: 'Élèves Non A Jour',
        data: ecoleData.map(e => e.eleveNonAJour),
        backgroundColor: 'rgba(170, 74, 68, 0.7)',
        stack: 'stack1',
      },
    ],
  };

  const bar4 = {
    labels: ecoleData.map(e => moment(e.date).format(APP_LOCAL_MONTH_FORMAT)),
    datasets: [
      {
        label: 'Personnel présent',
        data: ecoleData.map(e => e.personnelPresent),
        backgroundColor: 'rgba(147, 197, 114, 0.7)',
        stack: 'stack1',
      },
      {
        label: 'Personnel absent',
        data: ecoleData.map(e => e.personnelAbsents),
        backgroundColor: 'rgba(170, 74, 68, 0.7)',
        stack: 'stack1',
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
    },
    lineTension: '0.4',
    cutout: '60%',
  };

  return (
    <>
      <div className="center p-1">
        <h2> {currentEcole.nom}</h2>
      </div>
      <Row className="justify-content-center mb-5">
        <Col xs={{ span: 20 }} lg={{ span: 6 }}>
          <Doughnut data={dataPresenceEleves} options={options} />
          <h5 className="ml-4 p-2">Total élèves inscrits: {totalEleve} </h5>
        </Col>
        <Col xs={{ span: 24 }} lg={{ span: 13 }} offset={2}>
          <Bar data={bar1} options={options} />
        </Col>
      </Row>
      <Row className="justify-content-center mb-5">
        <Col xs={{ span: 20 }} lg={{ span: 6 }}>
          <Doughnut data={dataProf} options={options} />
          <h5 className="ml-4 p-2">Total enseignants: {totalProf} </h5>
        </Col>
        <Col xs={{ span: 24 }} lg={{ span: 13 }} offset={2}>
          <Bar data={bar2} options={options} />
        </Col>
      </Row>
      <Row className="justify-content-center mb-5">
        <Col xs={{ span: 20 }} lg={{ span: 6 }}>
          <Doughnut data={dataPersonnel} options={options} />
          <h5 className="ml-4 p-2">Total personnel: {totalPersonnel} </h5>
        </Col>
        <Col xs={{ span: 24 }} lg={{ span: 13 }} offset={2}>
          <Bar data={bar4} options={options} />
        </Col>
      </Row>
      <Row className="justify-content-center mb-5">
        <Col xs={{ span: 20 }} lg={{ span: 6 }}>
          <Doughnut data={dataPaiementEleves} options={options} />
        </Col>
        <Col xs={{ span: 24 }} lg={{ span: 13 }} offset={2}>
          <Bar data={bar3} options={options} />
        </Col>
      </Row>
    </>
  );
};

export default Home;
